import React, { Fragment } from 'react';
import { isEqual } from 'lodash';
/**
 * Author: NRK.
 */

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

// import Link from react-router-dom
import { Link } from 'react-router-dom';

// import material-ui core
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';

import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';

// import statusStyles, chipStyles
import { chipStyles } from './../../../styles/globalStyles/dataDisplayStyles';

import { logger } from './../../../utils/utils';

import { ChipLabels } from './../LabelPicker';

import { LFTooltip } from './../Tooltips';

// Styles consist of processStatusStyle
const useStyles = makeStyles((theme) => ({
  ...chipStyles(theme),
  grid: {
    flexGrow: 1,
  },
}));
/**
 * ColumnContent() (Comonent) Display summary detail in summary column (material-table)
 * @param {object} props  *Required
 * @param {string} props.issueId  *Required
 * @param {string} props.categoryName  *Required
 * @param {string} props.summary  *Required
 * @param {string} props.path ^Router path of issue activity
 * @param {string} props.reporter
 * @param {string} props.worker
 * @param {string} props.level, 1|2|3
 * @param {object} props.processStatus {processStatus_id, processStatus_name, processStatus_style}
 * @param {array} props.labels
 * @param {array} props.createDate
 * @param {array} props.modifyDate
 * @returns element summary detail
 */
const ColumnContent = ({
  issueId = '',
  categoryName = '',
  summary = '',
  path = '',
  reporter = '',
  worker = '',
  level = null,
  processStatus = null,
  labels = [],
  createDate = '',
  modifyDate = '',
  viewStatus = {},
}) => {
  const classes = useStyles();
  logger('ColumnContent render');

  return (
    <div className={classes.root}>
      <Typography component="div">
        <Box display="flex" flexWrap="wrap" alignItems="center">
          {/* check observer by Is viewStatus.byCategoryAndLevel false */}
          {!viewStatus.byCategoryAndLevel &&
            (viewStatus.observerWorker || viewStatus.observer) && (
              <Fragment>
                <Box>
                  <LFTooltip
                    title={`มีการติดตามเหตุละเมิดไว้ ในฐานะ ${
                      viewStatus.observerWorker ? 'คณะทำงาน' : 'ผู้ติดตามทั่วไป'
                    }`}
                  >
                    {viewStatus.observerWorker ? (
                      <VisibilityIcon
                        style={{ verticalAlign: 'middle' }}
                      />
                    ) : (
                      <VisibilityOutlinedIcon style={{ verticalAlign: 'middle' }} />
                    )}
                  </LFTooltip>
                </Box>
                <Box mr={0.5}></Box>
              </Fragment>
            )}
          <Box>
            <Link to={path}>{summary}</Link>
          </Box>
          <Box mr={0.5}></Box>
          {processStatus && (
            <Chip
              className={classes.chipStatusSmallStyle}
              label={processStatus.name}
              style={JSON.parse(processStatus.style)}
            />
          )}
        </Box>
      </Typography>
      <Typography variant="subtitle2" component="div" color="textSecondary">
        {/* Flexbox style */}
        <Box
          display="flex"
          flexWrap="wrap"
          bgcolor="background.paper"
          css={{ maxWidth: '100%' }}
        >
          <Box pt={0.5} pr={1}>
            รหัส: {issueId}
          </Box>
          <Box pt={0.5} pr={1}>
            วันที่แจ้ง: {createDate}
          </Box>
          <Box pt={0.5} pr={1}>
            ประเภท: {categoryName}
          </Box>
          {level && (
            <Box pt={0.5} pr={1}>
              ระดับ: {level}
            </Box>
          )}
          <Box pt={0.5} pr={1}>
            ผู้แจ้ง: {reporter}
          </Box>
          {worker && (
            <Box pt={0.5} pr={1}>
              ผู้รับเรื่อง: {worker}
            </Box>
          )}
          {/* {
            <Box pt={0.5} pr={1}>
              viewStatus: {JSON.stringify(viewStatus)}
            </Box>
          } */}
          {labels.length > 0 && <ChipLabels labels={labels} />}
        </Box>
      </Typography>
    </div>
  );
};

ColumnContent.propTypes = {
  issueId: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  categoryName: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  reporter: PropTypes.string.isRequired,
  worker: PropTypes.string,
  processStatus: PropTypes.object,
  labels: PropTypes.array,
  createDate: PropTypes.string.isRequired,
  modifyDate: PropTypes.string,
  viewStatus: PropTypes.object,
};

/**
 * By default it will only shallowly compare complex objects in the props object.
 * If you want control over the comparison,
 * you can also provide a custom comparison function as the second argument.
 * https://reactjs.org/docs/react-api.html
 * https://stackoverflow.com/questions/63502588/avoid-rerendering-child-when-passing-object-in-props
 */
export default React.memo(ColumnContent, isEqual);
